import React, { useContext, useState } from 'react'
import permisos from '../Tools/VerificarPermisos'
import { ContextGloball } from '../Context/ContextGlobal';
import ProtocoloInicio from './ProtocoloInicio';
import PrincipalAdminProtocolo from './PrincipalAdminProtocolo';

function MenuProtocolos() {
    const { setTitulo } = useContext(ContextGloball);
    const [subVentana, setSubVentana] = useState(0);
    const validarVentana = (item) => {
        var cls = subVentana === item ? "itemMenuOk w-100" : "itemMenu w-100";
        return cls;
    }
    function getContenido() {
        if(subVentana==1){
            return (<ProtocoloInicio />)
        }else if (subVentana==2){
            return (<PrincipalAdminProtocolo />)
        }
    }
    return (
        <>
            {subVentana==0&&<div className='container-fluid py-2'>
                <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-1'>
                    {permisos.validarPermiso('11') && <div className='col col-sm-6 col-md-4'>
                        <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(1)}`}
                            onClick={() => { setSubVentana(1); setTitulo('Procedimientos');}}>
                            <i className="fa-solid fa-school-circle-check"></i><span className="ms-1 "> Procedimientos</span></a>
                    </div>}
                    {permisos.validarPermiso('20') && <div className='col col-sm-6 col-md-4'>
                        <a className={`btn btn-sm text-light text-start bg-gradient w-100 ${validarVentana(2)}`}
                            onClick={() => { setSubVentana(2); setTitulo('Administrar Procedimientos');}}>
                            <i className="fa-solid fa-school-lock"></i><span className="ms-1 "> Admi Procedimiento</span></a>
                    </div>}
                </div>
            </div>}
            {getContenido()}
            {subVentana !== 0 && <button className='btn text-danger btn-flotante' onClick={() => { setTitulo('Procedimientos'); setSubVentana(0) }}><i className="fa-solid fa-circle-xmark fa-2xl"></i></button>}
        </>
    )
}

export default MenuProtocolos